<script>
    import {http} from '@/system/http.js';
    import CustomClientFieldsContainer from '@/system/components/apps/custom_client_fields/CustomClientFieldsContainer';
    import PhoneNumberInput from '@/system/components/global/form/PhoneNumberInput';
    import ClientForm from '@/online_booking/new/components/common_booking/ClientForm.vue';
    import { appendCustomAttributesToFormData } from '@/system/helpers/index.js';
    import Switchery from 'Components/global/form/Switchery.vue';
    import GoogleAnalyticsEvents from 'Modules/GoogleAnalytics/resources/assets/js/GoogleAnalyticsEvents'

    export default {

        data() {
            return {
                permalink: permalink,
                loading: false,
                user: null,
                settingsLogin: null,
                is_consent_enabled: false,
                consent_settings: null,
                online_booking_settings: null,
                consent_accepted: false,
                custom_client_fields: [],
                custom_attributes: {},
                cpr_field_required_override: false,
                form: {
                    name: '',
                    email: '',
                    phone: '',
                    address: '',
                    address_line_2: '',
                    zip: '',
                    zone: '',
                    country: '',
                    danmark: 0
                }
            }
        },

        mounted() {
            this.init();
        },

        methods: {

            init() {
                if (!this.permalink || this.permalink.trim() === '') {
                    return;
                }

                this.loading = true;

                http.get('/book/' + this.permalink + '/center/get')
                    .then(({data}) => {
                        this.is_consent_enabled = data.is_consent_enabled;
                        this.consent_settings = data.consent_settings;
                        this.online_booking_settings = data.online_booking_settings;
                        this.user = data.user;
                        this.custom_client_fields = data.custom_client_fields;
                        this.cpr_field_required_override = data.cpr_field_required_override;
                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            codeSent() {
                this.$event_bus.$emit('codeSent');
            },

            backToLogin() {
                this.$event_bus.$emit('backToLogin', {user: this.user, settingsLogin: this.settingsLogin});
            },

            register() {
                this.loading = true;

                this.$event_bus.$emit('beforeCode', 'signup');

                const dataFrm = new FormData($('#create-client-form')[0]);

                Object.keys(this.form).forEach((property) => {
                    dataFrm.append(property, this.form[property])
                })

                appendCustomAttributesToFormData(dataFrm, this.custom_attributes);

                http.post('/book/' + this.permalink + '/create-client', dataFrm)
                    .then(({data}) => {
                        this.$event_bus.$emit('codeSent', data);
                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                        if (errorBag) {
                            this.$setErrorBag(errorBag);
                        }
                    });

            },

            fbLogin() {
                var win = window.open('/book/' + this.permalink + '/submit-facebook', 'FacebookLoginWindow', 'height=500,width=600,scrollbars,status');
                var timer = setInterval(function() {
                    // Check if the client reached the last page of the OAuth flow
                    var url;
                    try {
                        url = win.location.href + '';
                    } catch (e) {
                        return;
                    }
                    var redirectUrl = [location.protocol, '//', location.host, location.pathname].join('');
                    // Determines if the client is on page after having unique account
                    var isBookingPage = url.indexOf('/book/') !== -1 && url.indexOf('/auth/') === -1
                    // Determines if the client is on page after choosing from 2 account
                    var isCenterPage = url.indexOf('/center') !== -1
                    // Check if there was an error when logging in
                    var $alerts = win.document.getElementsByClassName('alert-danger')
                    var $successes = win.document.getElementsByClassName('alert-success')
                    var hasSuccess = $successes.length > 0
                    var errors = []
                    for (var i = 0; i < $alerts.length; i++) {
                        errors.push($alerts[i].innerText.trim())
                    }

                    if (isBookingPage || isCenterPage) {
                        redirectUrl = redirectUrl + $.param({
                            //login_successful: hasSuccess,
                            errors: errors
                        });
                        win.postMessage({ fbLoggedIn: true }, '*')
                        win.close()
                        clearInterval(timer);
                        window.location.href = redirectUrl
                    }

                    if (win.closed) {
                        clearInterval(timer);
                        window.location.href = redirectUrl
                    }
                }, 1000);
            },

            goBackToChoose() {
                this.$event_bus.$emit('goBackToChoose');
            }
        },

        computed: {
            showCustomFields() {
                return this.custom_client_fields && this.custom_client_fields.length > 0;
            },
            showDanmarkGroups() {
                return (
                    this.user.is_sygeforsikring_danmark_connected &&
                    this.online_booking_settings.fields.danmark
                );
            },
        },

        components: {
            Switchery,
            ClientForm,
            CustomClientFieldsContainer,
            PhoneNumberInput,
        }
    };


</script>


<template>
    <div>

        <div class="col-sm-8 col-sm-offset-2">

            <div class="card-box login-box">

                <div class="text-center">
                    <h4 class="text-uppercase font-bold m-b-0">
                        {{ trans('online_booking.create_new_user') }}
                    </h4>
                </div>

                <div class="panel-body">
                    <form id="create-client-form" class="m-t-20" v-if="online_booking_settings">

                        <client-form
                            v-if="!loading"
                            v-model="form"
                            :nameOptions="{ display: true, required: false }"
                            :emailOptions="{ display: online_booking_settings.email_field, required: false }"
                            :phoneOptions="{ display: online_booking_settings.phone_field, required: false, dropdownParent: null }"
                            :addressOptions="{ display: online_booking_settings.fields.address, required: false, countrySelectParent: 'create-client-form' }"
                            :dobOptions="{ display: online_booking_settings.fields.dob, required: online_booking_settings.fields.dob_required }"
                            :cprOptions="{ display: online_booking_settings.fields.cpr || cpr_field_required_override, required: online_booking_settings.fields.cpr_required || cpr_field_required_override }"
                            :validationErrors="errors"
                            >
                        </client-form>

                        <template v-if="showCustomFields && !loading">
                            <custom-client-fields-container :custom-fields="custom_client_fields" :validation-errors="errors" errors-prefix="custom_attributes" v-model="custom_attributes"></custom-client-fields-container>
                        </template>

                        <div class="form-group" v-if="showDanmarkGroups">
                            <label for="danmark">{{ trans('apps.danmark.title') }}</label>
                            <switchery :text="trans('apps.danmark.are_you_a_member')" name="danmark" v-model.number="form.danmark" :light="true" active-color="var(--brand-primary)"></switchery>
                        </div>

                        <div class="form-group" :class="{ 'has-error' : errors.has('consent_accepted') }" v-if="is_consent_enabled && consent_settings.required_client_login">
                            <div class="m-t-0">
                                <div class="checkbox">
                                    <input id="consent_accepted_signup" type="checkbox" name="consent_accepted" v-model="consent_accepted">
                                    <label for="consent_accepted_signup" class="consent-label control-label">
                                        {{ consent_settings.checkbox_label }}
                                        <a data-toggle="modal" data-target="#consentModal" >({{ trans('online_booking.read_more') }})</a>
                                    </label>
                                </div>
                                <span v-show="errors.has('consent_accepted')" class="help-block m-b-0">{{ errors.first('consent_accepted') }}</span>
                            </div>
                        </div>


                        <div class="form-group text-center ">
                            <button type="button" class="btn btn-lg btn-custom btn-block"
                                    @click="register()" v-if="!loading">
                                {{ trans('online_booking.create_new_user') }}
                            </button>
                            <div class="btn btn-lg btn-custom btn-block btn-login-loading" v-if="loading">
                                <div class="preloader"></div>
                            </div>
                        </div>

                        <div v-if="user && user.is_facebook_client_login_enabled">
                            <div class="form-group">
                                <div class="row">
                                    <div class="span-fb-divider col-xs-12 ">
                                        <div>{{ trans('online_payment.or') }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group text-center ">
                                <button type="button" @click="fbLogin"
                                        class="btn btn-lg btn-facebook btn-block">
                                    <i class="zmdi zmdi-facebook-box m-r-10"></i>
                                    <span>{{ trans('online_booking.login_with_facebook') }}</span>
                                </button>
                            </div>
                        </div>

                        <div class="form-group m-b-0">
                            <div class="m-t-20 choose-user-bottom">
                                <a class="btn btn-default" @click="goBackToChoose">
                                    <i class="zmdi zmdi-chevron-left m-r-10 alert-ico"></i>
                                    {{ trans('global.back') }}
                                </a>
                            </div>
                        </div>


                    </form>

                </div>

            </div>

        </div>
</div>

</template>

<style>
#create-client-form .consent-label {
    color: #505458;
    font-size: 14px;
    font-weight: normal;
    padding-top: 0;
    color: #999;
    margin-left: 5px;
}
</style>
